import { Button, Input, Form, Select, Switch } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { GoogleMap, LoadScript, Marker, Autocomplete } from "@react-google-maps/api";
import { IoLocationOutline } from "react-icons/io5";
import * as Validation from "../../../../utils/helper/validation";
import toast from "react-hot-toast";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as Apis from "../../../../utils/helper/enum";
import globalRequest from "../../../../utils/global/globalRequest";
import config from "../../../../config";

const mapContainerStyle = {
  height: "400px",
  width: "100%",
};

const libraries = ["places"];

// let selectAssociateBranch = [];
const AddDropZoneTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const center = {
    lat: config.lat,
    lng: config.lng,
  };
  const [form] = Form.useForm();
  const [markerPosition, setMarkerPosition] = useState(center);
  const [address, setAddress] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectAssociateBranch, setSelectAssociateBranchList] = useState([]);
  const inputRef = useRef(null);
  const geocoder = useRef(null);
  const [checked, setChecked] = useState(false);
  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const location = place.geometry.location;
      setAddress(place.formatted_address);
      setMarkerPosition({
        lat: location.lat(),
        lng: location.lng(),
      });
    } else {
      // console.log("Autocomplete is not loaded yet!");
    }
  };

  const onMarkerDragEnd = (e) => {
    let newLat = e.latLng.lat();
    let newLng = e.latLng.lng();
    setMarkerPosition({
      lat: newLat,
      lng: newLng,
    });
    geocodeLatLng(newLat, newLng);
  };
  const geocodeLatLng = (lat, lng) => {
    if (!geocoder.current) {
      geocoder.current = new window.google.maps.Geocoder();
    }

    const latLng = { lat, lng };
    geocoder.current.geocode({ location: latLng }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          setAddress(results[0].formatted_address);
          setInputValue(results[0].formatted_address); // Update the input field with the address
        } else {
          // console.log("No results found");
        }
      } else {
        // console.log("Geocoder failed due to: " + status);
      }
    });
  };

  const getBranchList = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_DROPZONE.GET_BRANCH_LIST, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        const branchList = apiResponse?.data;
        const idNameArray = branchList.data.map((item1) => ({
          value: item1.id.toString(),
          label: item1.name,
          associate_drop_zone: item1.associate_drop_zone,
        }));
        setSelectAssociateBranchList(idNameArray);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const handleSubmit = async (values) => {
    if (values.status === true) values.status = "active";
    if (values.status === false) values.status = "inactive";
    values.latitude = markerPosition.lat;
    values.longitude = markerPosition.lng;
    values.address = address;
    const hasRange = values.rangeValues && values.rangeValues.trim() !== "";

    if (hasRange && !values.device_code) {
      toast.error("If Range is selected, then enter the device code as well.");
      return false;
    }
    if (hasRange) {
      values.range = values.rangeValues
        .split(",")
        .map((n) => Number(n.trim()))
        .filter((x) => !isNaN(x));

      delete values.rangeValues;
    }

    console.log("values", values);
    if (values.branch_id === undefined || values.branch_id === "undefined" || values.branch_id === "") values.branch_id = 0;

    try {
      let url = Apis?.MANAGE_DROPZONE?.CREATE;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_DROPZONE?.EDIT + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Dropzone created successfully";
        if (id) msg = "Dropzone updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-drop-zone");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_DROPZONE.GET_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;

        form.setFieldValue("name_en", data?.dropZoneLocales[0].name);
        form.setFieldValue("name_ar", data?.dropZoneLocales[1].name);
        form.setFieldValue("description_en", data?.dropZoneLocales[0].description);
        form.setFieldValue("description_ar", data?.dropZoneLocales[1].description);
        form.setFieldValue("discount", `${data?.discount}`);
        form.setFieldValue("status", data?.status === "active" ? true : false);
        form.setFieldValue("length", `${data?.length}`);
        form.setFieldValue("width", `${data?.width}`);
        form.setFieldValue("height", `${data?.height}`);

        form.setFieldValue("branch_id", data?.branchdata?.id ? `${data.branchdata.id}` : "");
        form.setFieldValue("device_code", data?.deviceCode);
        if (Array.isArray(data.range)) {
          form.setFieldValue("rangeValues", data.range.join(","));
        }
        // if(data?.associateBranchId<=0){
        //   if(data?.branchdata){
        //     form.setFieldValue("branch_id", data?.branchdata?.id);
        //   }else form.setFieldValue("branch_id", `${data?.associateBranchId > 0 ? data?.associateBranchId : '' }`);
        // }else form.setFieldValue("branch_id", `${data?.associateBranchId > 0 ? data?.associateBranchId : '' }`);

        setChecked(data?.status === "active" ? true : false);
        setAddress(data.address);
        setInputValue(data.address);
        setMarkerPosition({
          lat: data?.latitude,
          lng: data?.longitude,
        });
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getDetail(id);
    else {
      form.setFieldValue("status", true);
      setChecked(true);
    }
    getBranchList();
  }, []);
  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Drop zone Name (English)"
            name="name_en"
            rules={[
              {
                required: true,
                message: "Please enter your Drop zone Name (English).",
              },
              {
                max: 80,
                message: "Please enter max 80 character.",
              },
            ]}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value);
                form.setFieldValue("name_en", value.trimStart());
                handleInputChange("name_en");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Drop zone Name (Arabic)"
            name="name_ar"
            rules={[
              {
                required: true,
                message: "Please enter your Drop zone Name (Arabic).",
              },
              {
                max: 80,
                message: "Please enter max 80 character.",
              },
            ]}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value);
                form.setFieldValue("name_ar", value.trimStart());
                handleInputChange("name_ar");
              }}
            />
          </Form.Item>
          <Form.Item label="Address" name="address">
            <div className="responsive-map-container mt-4">
              <LoadScript googleMapsApiKey={config.GOOGLEMAPAPIKEY} libraries={libraries}>
                <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
                  <div
                    className="hello "
                    style={{
                      width: "40%",
                      position: "absolute",
                      zIndex: "1",
                      top: "20px",
                      left: "110px",
                      right: "0",
                      margin: "auto",
                      padding: "10px",
                    }}
                  >
                    <Input
                      placeholder="Enter a location"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      ref={inputRef}
                    />
                  </div>
                </Autocomplete>

                <GoogleMap mapContainerStyle={mapContainerStyle} center={markerPosition} zoom={12}>
                  <Marker position={markerPosition} draggable={true} onDragEnd={onMarkerDragEnd} />
                </GoogleMap>
              </LoadScript>
              <div style={{ marginTop: "20px" }}>
                <h3 style={{ fontWeight: "bold", marginBottom: "12px" }}>Street Address</h3>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <IoLocationOutline style={{ marginRight: "10px" }} />
                  {address}
                </p>
              </div>
              {/* <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1737.6221882978507!2d-98.48650795000005!3d29.421653200000023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c58aa57e6a56f%3A0xf08a9ad66f03e879!2sHenry+B.+Gonzalez+Convention+Center!5e0!3m2!1sen!2sus!4v1393884854786"
                  width={600}
                  height={450}
                  style={{ border: 0 }}
                /> */}
            </div>
          </Form.Item>
          <Form.Item
            label="Discount %"
            name="discount"
            // max={100}
            rules={[
              {
                required: true,
                message: "Please enter your Discount %.",
              },
              // {
              //   max: 100,
              //   message: "Please enter value less than 100.",
              // }
            ]}
          >
            <Input
              size="large"
              suffix="%"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "float|max-value:100");
                form.setFieldValue("discount", value);
                handleInputChange("discount");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Description (English)"
            name="description_en"
            rules={[
              {
                required: true,
                message: "Please enter your Description (English).",
              },
              {
                max: 300,
                message: "Please enter max 300 character.",
              },
            ]}
          >
            <TextArea
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value);
                form.setFieldValue("description_en", value.trimStart());
                handleInputChange("description_en");
              }}
            />
          </Form.Item>
          <Form.Item
            label=" Description (Arabic)"
            name="description_ar"
            rules={[
              {
                required: true,
                message: "Please enter your  Description (Arabic).",
              },
              {
                max: 300,
                message: "Please enter max 300 character.",
              },
            ]}
          >
            <TextArea
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value);
                form.setFieldValue("description_ar", value.trimStart());
                handleInputChange("description_ar");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Show in store"
            name="status"
            rules={[
              {
                required: true,
                message: "Please select Show in store.",
              },
            ]}
          >
            <Switch
              checkedChildren="active"
              unCheckedChildren="inactive"
              checked={checked}
              onChange={(value) => {
                setChecked(value);
                form.setFieldValue("status", value);
                handleInputChange("status");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Length"
            name="length"
            rules={[
              {
                required: true,
                message: "Please enter Length.",
              },
              {
                max: 6,
                message: "Please enter max 6 digit include decimal.",
              },
            ]}
          >
            <Input
              size="large"
              suffix="CM"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "float|min-value:0.1");
                form.setFieldValue("length", value.trimStart());
                handleInputChange("length");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Width"
            name="width"
            rules={[
              {
                required: true,
                message: "Please enter Width.",
              },
              {
                max: 6,
                message: "Please enter max 6 digit include decimal.",
              },
            ]}
          >
            <Input
              size="large"
              suffix="CM"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "float|min-value:0.1");
                form.setFieldValue("width", value.trimStart());
                handleInputChange("width");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Height"
            name="height"
            rules={[
              {
                required: true,
                message: "Please enter Height.",
              },
              {
                max: 6,
                message: "Please enter max 6 digit include decimal.",
              },
            ]}
          >
            <Input
              size="large"
              suffix="CM"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "float|min-value:0.1");
                form.setFieldValue("height", value.trimStart());
                handleInputChange("height");
              }}
            />
          </Form.Item>
          <Form.Item label="Associate Branch" name="branch_id">
            <Select
              allowClear
              size="large"
              placeholder="Select"
              options={selectAssociateBranch}
              // options={selectAssociateBranch.map((branch) => ({
              //   label: branch.label,
              //   value: branch.value,
              //   disabled: branch.associate_drop_zone > 0, // Disable if associateBranchId > 0
              // }))}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                form.setFieldValue("branch_id", value ?? "");
                handleInputChange("branch_id");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Device Code"
            name="device_code"
            rules={[
              {
                required: false,
                message: "Please enter Device Code.",
              },
              {
                max: 10,
                message: "Please enter max 10 digit integer only.",
              },
            ]}
          >
            <Input
              size="large"
              type="number"
              className="no-spinner"
              maxLength={10}
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, "")
                if (value.length > 10) value = value.slice(0, 10);
                form.setFieldValue("device_code", value.trimStart());
                handleInputChange("device_code");
              }}
            />
          </Form.Item>
          <h5 className="text-md">Enter the range</h5>
          <div className="grid grid-cols-1 my-2">
            <Form.Item
              name="rangeValues"
              rules={[
                {
                  validator(_, value) {
                    if (!value) return Promise.resolve();

                    const numbers = value
                      .split(",")
                      .map((n) => n.trim())
                      .filter((x) => x !== "");

                    for (let num of numbers) {
                      if (!/^[0-9]{1,2}$/.test(num)) {
                        return Promise.reject(
                          new Error("Each value must be a 1–2 digit number.")
                        );
                      }
                      if (Number(num) <= 0) {
                        return Promise.reject(
                          new Error("All values must be greater than 0.")
                        );
                      }
                    }
                    const unique = new Set(numbers);
                    if (unique.size !== numbers.length) {
                      return Promise.reject(
                        new Error("Duplicate numbers are not allowed. All values must be unique.")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter numbers e.g. 10,20,30"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/[^0-9,]/g, "");
                  value = value
                    .split(",")
                    .map((v) => v.slice(0, 2)) // restrict each block to 2 digits
                    .join(",");

                  form.setFieldValue("rangeValues", value);
                  handleInputChange("rangeValues");
                }}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
      <div className="flex justify-end gap-3">
        <Button onClick={() => navigate("/manage-drop-zone")}>Cancel</Button>
        <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
          Save
        </Button>
      </div>
    </>
  );
};
export default AddDropZoneTab;
